import { MenuItem, TextField } from '@mui/material';
import { TEXTS } from '../../core/texts';
import { ColumnBoxFlexFullWidth, FlexBox, FlexBoxFullWidth } from './boxes';
import { ChangeEvent } from 'react';
import { PAYMENT_RATE_MAP, PaymentRateType } from '../../enums/paymentRateType';
import { ValidationErrorState } from '../../types/validationErrorState';
import { Validator } from '../../core/Validator';
import { CURRENCY_CODES } from '../../core/currencies';

interface Props {
  rateAmount: number,
  rateCurrency: string,
  rateType: PaymentRateType,
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void,
  validationErrors: ValidationErrorState,
  disabled: boolean,
  amountNamespace?: string;
  currencyNamespace?: string;
}

const RateAvailability = ({
                            rateAmount,
                            rateType,
                            rateCurrency,
                            handleInputChange,
                            validationErrors,
                            disabled,
                            currencyNamespace = 'rateCurrency',
                            amountNamespace = 'rateAmount'
                          }: Props) => {
  return (
    <ColumnBoxFlexFullWidth>
      <FlexBoxFullWidth flexDirection={{ mobile: 'column', laptop: 'row' }}>
        <FlexBox mb={{ mobile: 4, laptop: 0 }} flexDirection={{ mobile: 'column', tablet: 'row' }}>
          <TextField
            name={'amount'} value={rateAmount} onChange={handleInputChange} label={TEXTS.AMOUNT}
            type={'number'} required={!disabled && !!Validator.LENGTHS.AVAILABILITY[amountNamespace]?.min}
            sx={{ minWidth: { mobile: 80, laptop: 150 }, width: { mobile: '100%', tablet: '50%', laptop: 'initial' } }}
            variant={disabled ? 'standard' : 'outlined'}
            error={!!validationErrors[amountNamespace]} helperText={validationErrors[amountNamespace]} disabled={disabled}
          />
          <TextField name={'currency'} onChange={handleInputChange} label={TEXTS.CURRENCY} value={rateCurrency}
                     required={!disabled && !!Validator.LENGTHS.AVAILABILITY[currencyNamespace]?.min}
                     error={!!validationErrors[currencyNamespace]}
                     disabled={disabled} helperText={validationErrors[currencyNamespace]}
                     variant={disabled ? 'standard' : 'outlined'}
                     sx={{
                       ml: { tablet: 2, laptop: 10 },
                       mr: { mobile: 0, laptop: 10 },
                       mt: { mobile: 4, tablet: 0 },
                       minWidth: { mobile: 80, laptop: 100 },
                       width: { mobile: '100%', tablet: '50%', laptop: 'initial' }
                     }}
                     select SelectProps={{ MenuProps: { sx: { maxHeight: { mobile: 200, tablet: 300 } } } }}
          >
            {
              CURRENCY_CODES.map(code => (
                <MenuItem key={code} value={code}>
                  {code}
                </MenuItem>
              ))
            }
          </TextField>
        </FlexBox>
        <TextField name={'type'} value={rateType} onChange={handleInputChange} label={TEXTS.RATE_TYPE}
                   required={!disabled && !!Validator.LENGTHS.AVAILABILITY['rateType']?.min}
                   error={!!validationErrors['rateType']}
                   helperText={validationErrors['rateType']} fullWidth select disabled={disabled}
                   SelectProps={{ MenuProps: { sx: { maxHeight: { mobile: 200, tablet: 300 } } } }}
                   variant={disabled ? 'standard' : 'outlined'}
        >
          {
            Object.values(PaymentRateType).map(rate => (
              <MenuItem key={rate} value={rate}>
                {PAYMENT_RATE_MAP[rate]}
              </MenuItem>
            ))
          }

        </TextField>
      </FlexBoxFullWidth>


    </ColumnBoxFlexFullWidth>
  );
};

export default RateAvailability;